export default {
  cn: {
    clientParentInfo: {
      title:'客户上级信息',
      search:'搜索',
      download:'下载',
      downloadAll:'下载全部',
      mt4Number:'MT4账号',
      downTips:'数据过多无法显示,将自动生成Excel!',
      errorTips: '查询出错',
      table:{
        cln_id:'帐号',
        acc_type:'类型',
        ib_type:'IB类型',
        area_code:'大区',
        area_name:'大区名',
        manager:'经理',
        manager_name:'经理名',
        manager_email:'经理邮箱',
        sales:'员工',
        sales_name:'员工名',
        sales_email:'员工邮箱',
        create_date:'创建时间',
      },
      roomtable:{
        addtitle:'添加直播间信息',
        edittitle:'编辑直播间信息',
        roomName:'直播间名称',
        roomAccount:'直播间账号',
        addbtn:'添加',
        closebtn:'关闭',
        roomList:'直播间列表',
        operate:'操作',
        edit:'编辑',
        delete:'删除',
        save:'保存'
      },
      datePicker:{
        startTime:'开始日期',
        endTime:'结束日期',
        to:'至',
      }
    }
  },
  hk: {
    clientParentInfo: {
      title:'客戶上級信息',
      search:'搜索',
      download:'下载',
      downloadAll:'下载全部',
      mt4Number:'MT4賬號',
      downTips:'数据过多无法显示,将自动生成Excel!',
      errorTips: '查询出错',
      table:{
        cln_id:'帐号',
        acc_type:'类型',
        ib_type:'IB类型',
        area_code:'大区',
        area_name:'大区名',
        manager:'经理',
        manager_name:'经理名',
        manager_email:'经理邮箱',
        sales:'员工',
        sales_name:'员工名',
        sales_email:'员工邮箱',
        create_date:'创建时间',
      },
      roomtable:{
        addtitle:'添加直播間信息',
        edittitle:'編輯直播間信息',
        roomName:'直播間名稱',
        roomAccount:'直播間賬號',
        addbtn:'添加',
        closebtn:'關閉',
        roomList:'直播間列表',
        operate:'操作',
        edit:'編輯',
        delete:'刪除',
        save:'保存'
      },
      datePicker:{
        startTime:'开始日期',
        endTime:'结束日期',
        to:'至',
      }
    }
  },
  en: {
    clientParentInfo: {
      title:'Client Parent Information',
      search:'Search',
      download:'Download',
      downloadAll:'Download All',
      mt4Number:'MT4 Account',
      downTips:'Too much data, will auto download Excel!',
      errorTips: 'Search Error',
      table:{
        cln_id:'Client ID',
        acc_type:'Client Type',
        ib_type:'IB Type',
        area_name:'Area Name',
        area_code:'Area Code',
        manager:'Manager',
        manager_name:'Manager Name',
        manager_email:'Manager Email',
        sales:'Sales',
        sales_name:'Sales Name',
        sales_email:'Sales Email',
        create_date:'Create Date',
      },
      roomtable:{
        addtitle:'Add live steam information',
        edittitle:'Edit live steam information',
        roomName:'Live steam name',
        roomAccount:'Live steam account',
        addbtn:'add',
        closebtn:'close',
        roomList:'Live steam list',
        operate:'operate',
        edit:'edit',
        delete:'delete',
        save:'save'
      },
      datePicker:{
        startTime:'Start Time',
        endTime:'End Time',
        to:'To',
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/MultiLanguage/clientParentInfo.js